export enum GradeLineSource {
  DEFAULT = "DEFAULT",
  MODELED = "MODELED",
}
